var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._b({}, "el-dialog", _vm.$attrs, false),
    [
      _c("p", { staticClass: "tips" }, [
        _c("i", {
          staticClass: "el-icon-warning",
          staticStyle: { color: "#f8b762", margin: "0 10px" }
        }),
        _vm._v(
          "\n    将签署位置批量放置在指定页面的同一位置，每份文件单个签署方最多可设置30个签署位置\n  "
        )
      ]),
      _c(
        "el-form",
        {
          ref: "ApplyFormRef",
          attrs: {
            "label-position": "top",
            model: _vm.ApplyForm,
            rules: _vm.rules
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "选择应用页面", prop: "pageMode" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.RadioChange },
                  model: {
                    value: _vm.ApplyForm.pageMode,
                    callback: function($$v) {
                      _vm.$set(_vm.ApplyForm, "pageMode", $$v)
                    },
                    expression: "ApplyForm.pageMode"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v("全部页面")
                  ]),
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("奇数页面")
                  ]),
                  _c("el-radio", { attrs: { label: "3" } }, [
                    _vm._v("偶数页面")
                  ]),
                  _c("el-radio", { attrs: { label: "4" } }, [
                    _vm._v("指定页面")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm.ApplyForm.pageMode === "4"
            ? _c(
                "el-form-item",
                { attrs: { label: "指定页面", prop: "desi" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "请输入页码或页码范围，用逗号分隔 例：1，2，4-6"
                    },
                    model: {
                      value: _vm.ApplyForm.desi,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.ApplyForm,
                          "desi",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ApplyForm.desi"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.$emit("BatchSettinsClose", { status: "close" })
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.ApplyAction("submit")
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b100ee6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b100ee6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/contract-view/components/BatchSettingsPup.vue
// module id = uNcf
// module chunks = 2 3 6 8 12 14 15 16 18 19 20 21 22 25 33 35 36 44 45 46 49